/**
 * Service API pour les coaching_sessions (Module Seances v2 backend).
 * Utilise le client axios partage du projet (services/api.js).
 */
import api from './api'
import { getErrorMessage as exoErrorMessage } from './procedes'

// ─── Sessions ─────────────────────────────────────────────────────

export async function listSessions({
  status, date_from, date_to, is_template, theme,
  page = 1, size = 20,
} = {}) {
  const params = {}
  if (status) params.status = status
  if (date_from) params.date_from = date_from
  if (date_to) params.date_to = date_to
  if (typeof is_template === 'boolean') params.is_template = is_template
  if (theme) params.theme = theme
  params.page = page
  params.size = size
  const { data } = await api.get('/coaching-sessions/', { params })
  return data
}

export async function listSessionTemplates({ page = 1, size = 50, theme } = {}) {
  const params = { page, size }
  if (theme) params.theme = theme
  const { data } = await api.get('/coaching-sessions/templates/', { params })
  return data
}

export async function getSession(id) {
  const { data } = await api.get(`/coaching-sessions/${id}/`)
  return data
}

export async function createSession(payload) {
  const { data } = await api.post('/coaching-sessions/', payload)
  return data
}

export async function updateSession(id, payload) {
  const { data } = await api.patch(`/coaching-sessions/${id}/`, payload)
  return data
}

export async function deleteSession(id) {
  await api.delete(`/coaching-sessions/${id}/`)
}

export async function duplicateSession(id) {
  const { data } = await api.post(`/coaching-sessions/${id}/duplicate/`)
  return data
}

export async function saveAsTemplate(id, { template_name, template_description }) {
  const { data } = await api.post(
    `/coaching-sessions/${id}/save-as-template/`,
    { template_name, template_description },
  )
  return data
}

// ─── Blocks (nested) ──────────────────────────────────────────────

export async function addBlock(sessionId, payload) {
  const { data } = await api.post(
    `/coaching-sessions/${sessionId}/blocks/`,
    payload,
  )
  return data
}

export async function updateBlock(sessionId, blockId, payload) {
  const { data } = await api.patch(
    `/coaching-sessions/${sessionId}/blocks/${blockId}/`,
    payload,
  )
  return data
}

export async function deleteBlock(sessionId, blockId) {
  await api.delete(`/coaching-sessions/${sessionId}/blocks/${blockId}/`)
}

export async function reorderBlocks(sessionId, items) {
  // items = [{id, position}, ...]
  const { data } = await api.patch(
    `/coaching-sessions/${sessionId}/blocks/reorder/`,
    { items },
  )
  return data
}

// ─── Suggestion engine (legacy /api/seances/suggestion/) ──────────

export async function getSuggestion({ season } = {}) {
  const params = {}
  if (season) params.season = season
  const { data } = await api.get('/seances/suggestion/', { params })
  return data
}

// Re-export pour cohérence côté composants
export { exoErrorMessage as getErrorMessage }
